var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"uesrtext"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"placeholder":"按 Ctrl + Enter 发送"},domProps:{"value":(_vm.content)},on:{"keyup":_vm.addMessage,"input":function($event){if($event.target.composing)return;_vm.content=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }